import React from 'react';
import { useSelector } from 'react-redux';

import { useTheme } from '@veneer/core';

import { Background, Message } from '../../components/welcome-message/styled';
import { useDependencyManagerContext } from '../../contexts/dependencyManager';
import { OperationResult, OperationStatus } from '../../types';
import { User } from '../../types/user';
import { RootState } from '../../store';

const WelcomeMessage: React.FC = () => {
  const theme = useTheme();
  const { translate } = useDependencyManagerContext();

  const {
    user,
    getUser: { status: getUserStatus }
  }: {
    user: User;
    getUser: OperationResult;
  } = useSelector((state: RootState) => state.UserReducer);

  return (
    <Background $veneerTheme={theme}>
      {getUserStatus === OperationStatus.COMPLETED ? (
        <h1
          className="title-regular"
          data-testid="react-device-management-mfe-welcome-message-title"
        >
          {translate('components.welcome-component.title', {
            givenName: user?.givenName
          })}
        </h1>
      ) : null}
      <Message
        className="body-regular"
        $veneerTheme={theme}
      >
        {translate('components.welcome-component.description')}
      </Message>
    </Background>
  );
};

export default WelcomeMessage;
